// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1Vw-A","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1CavG"};